import { render, staticRenderFns } from "./C-1b__CategoriesList_Dialog-ConfirmDelete.vue?vue&type=template&id=4eb29964&scoped=true&"
import script from "./C-1b__CategoriesList_Dialog-ConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./C-1b__CategoriesList_Dialog-ConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./C-1b__CategoriesList_Dialog-ConfirmDelete.vue?vue&type=style&index=0&id=4eb29964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb29964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
